module.exports = __webpack_public_path__ + "img/qilin-stage2-hungry.490cb68d.png";